import {
  ErrorMessages,
  SharedFeature,
  getFullPageError
} from '@com-delta-idp/mnx-skymiles-shared';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as Adapters from '../../adapters';
import {
  LANDING_PAGE_FEATURE_KEY,
  State,
  landingPageAdapter
} from '../reducers/landing-page.reducer';

// Lookup the 'Shared' feature state managed by NgRx
export const getSharedState = createFeatureSelector<SharedFeature.State>(
  SharedFeature.SHARED_FEATURE_KEY
);

const { selectEntities: selectSharedEntities } =
  SharedFeature.sharedAdapter.getSelectors();

export const getSharedEntities = createSelector(
  getSharedState,
  (state: SharedFeature.State) => {
    return selectSharedEntities(state);
  }
);

// Lookup the 'Landing Page' feature state managed by NgRx
export const getLandingPageState = createFeatureSelector<State>(
  LANDING_PAGE_FEATURE_KEY
);

const { selectEntities } = landingPageAdapter.getSelectors();

export const getLandingPageEntities = createSelector(
  getLandingPageState,
  (state: State) => selectEntities(state)
);

export const getLandingPageLoaded = createSelector(
  getLandingPageState,
  (state: State) => state.loaded
);

export const getLandingPageError = createSelector(
  getLandingPageState,
  (state: State) => state.error
);

export const getMedallionBanner = createSelector(
  getLandingPageEntities,
  getSharedEntities,
  (landingPageEntities, sharedEntities) =>
    Adapters.getMedallionBanner(
      landingPageEntities['aem-medallion-banner']?.aemMedallionBanner,
      sharedEntities['user-session']?.userSession,
      landingPageEntities['aem-feature-flags']?.aemFeatureFlags?.flags
        .medallionBanner,
      landingPageEntities['aem-medallion-banner-error']
        ?.aemMedallionBannerError,
      landingPageEntities['aem-error-messages']?.aemErrorMessages
    )
);

export const getMenu = createSelector(getLandingPageEntities, (entities) =>
  Adapters.getMenu(
    entities['aem-feature-flags']?.aemFeatureFlags?.flags.menu,
    entities['aem-menu']?.aemMenu,
    entities['aem-menu-error']?.aemMenuError,
    entities['aem-error-messages']?.aemErrorMessages,
    entities['business-traveler-content']?.businessTraveler,
    entities['business-traveler-feature-flag-content']
      ?.aemBusinessTravelerFeatureFlag
  )
);

export const getBaseContentError = createSelector(
  getLandingPageEntities,
  (entities) =>
    getFullPageError(
      [
        entities['aem-error-messages-error']?.aemErrorMessagesError,
        entities['aem-feature-flags-error']?.aemFeatureFlagsError,
        entities['aem-menu-error']?.aemMenuError,
        entities['aem-medallion-banner-error']?.aemMedallionBannerError
      ],
      ErrorMessages
    )
);
